import DashboardLayout from "@/components/app-layout";
import { Building2 } from "lucide-react";
import { Outlet } from "react-router";

const navItems = [
  {
    title: "Brands",
    href: "/",
    icon: <Building2 className="mr-2 h-4 w-4" />,
  },
];

export default function DashboardPage() {
  return (
    <DashboardLayout navItems={navItems}>
      <Outlet />
    </DashboardLayout>
  );
}
